import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Table
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import Sanitize from '../../Sanitize';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import MessagePage from '../../views/MessagePage/';
const GLOBAL = require('../../Globals');

class Report extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			ckdate : '',
			posts: [],
			postFilter : [],
			_redirect : false,
			_redirectView : false,
			loading: false,
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			stdname : '',
			staname : '',
			stdregno : '',
			stdmobno : '',
			clas : [],
			rowdata : [],
			stadata : [],
			purp : '',
			cls : '',
			section : '',
			view : 1,
			result : 1
		}
		this.basestate = this.state;
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onMobChange = this.onMobChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onStatusChange = this.onStatusChange.bind(this);
		this.onPurposeChange = this.onPurposeChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getclass();
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		console.log(this.state);
		
	}
	
	onClassChange(e){
		
		this.state.cls = e.target.value;
	}
	
	onSecChange(e){
		
		this.state.section = e.target.value;
	}
	
	onDateChange(e){
	
		this.state.ckdate = e.target.value;
		console.log(this.state);
	}

	onSearchChange(e){
		
		this.state.stdname = e.target.value;
	}
	
	onRegnoSearchChange(e){
		
		this.state.stdregno = e.target.value;

	}
	
	onStatusChange(e){
		
		this.state.staname = e.target.value;
	}
	
	onPurposeChange(e){
		
		this.state.purp = e.target.value;
		
		
	}
	
	onMobChange(e){
		
		this.state.stdmobno = e.target.value;

	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	clear(){
		
		//this.state.ckdate = '';
		this.state.cls = '';
		this.state.stdregno = '';
		this.state.staname = '';
		this.state.purp = '';
		this.state.stdmobno = '';
	}

		
	tclear(){
		
		this.state.ckdate = '';
		this.state.cls = '';
		this.state.stdregno = '';
		this.state.staname = '';
		this.state.purp = '';
		this.state.stdmobno = '';
		this.state.postFilter = [];
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
			PostData('message/getsmsfullreport',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson != '1'){
					this.setState({
						loading:false,
						posts : responseJson,
						postFilter : responseJson,
						view : 2,
						result : 2
				   });
				   this.clear();
				   document.getElementById("repform").reset();
				}
				else{
					this.tclear();
					document.getElementById("repform").reset();
					this.setState({
						result : 1,
						loading:true
					});
					alert('No Data Found!..');
				}
			});	
	}
	

	
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		//this.getdata();
		this.getclass();
		this.getrowtypes();
		this.getsmsstatus();
		console.log(this.state);
	}
	
	
	getdata(){
		this.setState({loading:true});
		this.setState({posts : []});	
		GetData('message/getsmsfullreport/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson,
					loading:false
				});
				$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	
	
	/** get SMS rowtypes **/
	getrowtypes(){
		
		GetData('message/getsmspurpose/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rowdata : responseJson
				});
			}
		});
	}
	
	
	/** get SMS Status **/
	getsmsstatus(){
		
		GetData('message/getsmsstatus/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					stadata : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('message/getclassbyacyear/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					clas : responseJson
				});
			}
		});
	}
	
	 
	
	
	
  render() {
	  
	  
	
	var items = this.state.clas;
	var stausval = this.state.stadata
    var purposes = this.state.rowdata;
	
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	if(this.state.view == 2 && this.state.result == 2){
		
		$("#tab_data").show();
	}
	else{
		
		$("#tab_data").hide();
	}
	
	$("#myInput").on("keyup", function() {
			var value = $(this).val().toLowerCase();
			$("#rep_body tr").filter(function() {
			  $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
			});
  });

	
	function getdateofdt(date){
		      
			  var date1 = new Date(date);
		      var year = date1.getFullYear();
			  var month = (date1.getMonth()+1);
			  var day   = date1.getDate()
			  var strTime = day + '-' + month + '-' + year;
			  return strTime;
			
	  }
	
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
			return <tr key = {item}>
				<td width="50" className="tablewidth">{i+1}</td>
				<td width="350">{getdateofdt(item.send_date)}</td>
				<td width="250">{item.send_time}</td>
				<td width="400">{item.stname}</td>
				<td width="250">{item.member}</td>
				<td width="150">{item.classname}</td>
				<td width="100">{item.secname}</td>
				<td width="200">{item.mobile}</td>
				<td width="200">{item.message}</td>
				<td width="200">{Sanitize.replacepurpose(item.rowtype)}</td>
				<td width="100">{item.response}</td>
			</tr>;
		
	});
	
	
	$("#clas").change(function(){
		
		var fr = $(this).val();
		
		$.get(GLOBAL.BASE_URL+'message/getsecbyclass/'+fr,function(o){
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.section)
					.text(value.secs)); 	
										
			});	
			
		},'json');
	
	});

	
    return (
		<div>
		  <MessagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>SMS Report</strong>
						<br />
						<br />
						 <form action="" method="post" role="form" id="repform" encType="multipart/form-data" onSubmit={this.onSubmit} >	
							 &nbsp;&nbsp; Reg No : &nbsp;&nbsp;
								<input type="text" name="stdregno" onChange={this.onRegnoSearchChange} />&nbsp;&nbsp;&nbsp;
							Name : &nbsp;&nbsp;
								<input type="text" name="stdname" id="myInput" onChange={this.onSearchChange} />&nbsp;&nbsp;&nbsp;&nbsp;
							Mobile : &nbsp;&nbsp;
								<input type="text" name="stdmobno" onChange={this.onMobChange} />&nbsp;&nbsp;&nbsp;&nbsp;
							Class : &nbsp;&nbsp;
								<select name="cls" onChange={this.onClassChange} id="clas"> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.class }>{item.cls}</option>;
										})
									}
								</select>&nbsp;&nbsp;
							Section : &nbsp;&nbsp;
								<select name="section" onChange={this.onSecChange} id="secs">
												
								</select>&nbsp;&nbsp;
								<br />
								<br />
							 &nbsp;&nbsp; Status : &nbsp;&nbsp;
								<select name="staname" onChange={this.onStatusChange} id="ressel"  >
								<option value="">Select Status</option>
									{
									stausval.map(function (item) {
											return <option value={item.response}>{item.response}</option>;
										})
									}
								 </select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								 
								Category : &nbsp;&nbsp;
								<select name="purp" onChange={this.onPurposeChange} > 
									<option value="">Select Category</option>
									{
										purposes.map(function (item) {
											return <option value={item.rowtype }>{Sanitize.replacepurpose(item.rowtype)}</option>;
										})
									}
								</select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								
								Date : &nbsp;&nbsp;
								<input type="date" name="ckdate" onChange={this.onDateChange} />&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
								<Button size="sm" color="primary" onClick={this.onSubmit}><i className="fa fa-dot-circle-o"></i> Search</Button>
							</form>	
							<br />
							Total Reports : <span>{this.state.postFilter.length}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							 <ReactHTMLTableToExcel
						id="test-table-xls-button"
						className="download-table-xls-button btn-right"
						table="table-to-xls_report"
						filename="smsreport"
						sheet="tablexls"
						Button size="xs"
						buttonText="Export"/>
					</CardHeader>
					<CardBody id="tab_data">
					  <Col md="12">
						<Table responsive striped id="table-to-xls_report">
						<thead>
							<tr>
								<th width="50" className="tablewidth">S.No</th>
								<th width="350">Send Date</th>
								<th width="250">Send Time</th>
								<th width="400">Student Name</th>
								<th width="200">Register No</th>
								<th width="150">Class</th>
								<th width="100">Section</th>
								<th width="200">Mobile</th>
								<th width="200">Message</th>
								<th width="200">Category</th>
								<th width="100">Status</th>
							</tr>
						</thead>
						<tbody id="rep_body">
							{renderTodos}
						</tbody>
					 </Table>
					 </Col>
					<Col md="4">
					  <Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.todosPerPage}
							pageRangeDisplayed={3}
							totalItemsCount={this.state.postFilter.length}
							onChange={this.handlePageChange}
						/>
					  </Col>
					  <Col md="2">
					   <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					  </Col>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Report;


// WEBPACK FOOTER //
// ./src/message/Report/Report.js